import { MenuConfig } from '@tencent/workbench';
import { MenuKey } from '../../schema/menu-schema/common';
import i18n from '@i18next/i18n';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.FILE_INFO,
        respectOffline: true,
        content: i18n.t<string>('文档信息'),
    },
];

